<template>
    <div id="container" type="vmapsearch">
        <template v-if="!listOnly">
            <div class="page page-search" :class="[`${msp.currentViewStatus}`, {'split-view': msp.isSplitView}, { filterShortcutsEnabled }, {'no-filter': noFilter}]"
                v-ga:request="{pageType:'vmapsearch', state: msp}" v-ga:page="{pageType:'vmapsearch',glb: glb, state: msp}">
                <mvtHeader :searchInput="currentSearchText" :geoInfo="hasGeoInfoInSearchUrl ? msp.geo : null" >
                    <template v-slot:right>
                        <div class="saveContainer" >
                            <a :href="('tel:' + getHeaderPhoneNumber)" class="small circle brand active hidden-md hidden-lg" v-nhs:click="{code: 'PhoneCall'}" aria-label="phone call">
                                <i class="icon-phone"></i>
                            </a>
                            <mvtToastLinked class="myTooltip"/>
                        </div>
                    </template>
                </mvtHeader>
                <main style="display:contents">
                    <searchFilter />
                    <SplitTreatments v-if="filterShortcutsEnabled" :names="['movoto-msp-shortcut-links-CW-3416']">
                        <template #default="{ treatments, isReady }">
                            <filterShortcuts v-if="isReady && (treatments['movoto-msp-shortcut-links-CW-3416'] === 'on')" :filters="msp.shortcutFilters" :filter="msp.filter" :geo="msp.geo" :key="msp.filterType" />
                        </template>
                    </SplitTreatments>
                    <searchMap ref="searchMapRef" />
                    <searchList @searchNearBy="fitNearbySearch"/>
                    <div class="msp-bottom-center" v-if="showBottomCTAs && componentMounted">
                        <div>
                            <buttonGroup :buttons="buttonGroupButtons" class="w-85 hidden-sm hidden-md hidden-lg"/>
                        </div>
                    </div>
                </main>
            </div>
            <mvtPopSignin />
            <mvtDialogCenter></mvtDialogCenter>
            <hearstLogo/>
            <mvtToastCenter />
            <mvtSearchFilter v-model="msp.filter" @changed="onChanged" :resultCount="msp.totalCount">
                <searchCommunicate class="mvt-searchfilter-item"></searchCommunicate>
                <ul class="mvt-searchfilter-item hidden-default grid xs-grid-cols-1 gap-2" id="citiesList" v-if="getNearbyCities && getNearbyCities.length">
                    <li v-for="city in getNearbyCities" :key="city.id">
                        <button type="button" @click="updateSearchTerm(city.sitemapCityPropertyPageUrl)">{{city.displayName}}</button>
                    </li>
                </ul>
                <ul class="mvt-searchfilter-item hidden-default grid xs-grid-cols-1 gap-2" id="neighborhoodsList" v-if="getNearbyNeighborhood && getNearbyNeighborhood.length">
                    <li v-for="neighborhood in getNearbyNeighborhood" :key="neighborhood.id">
                        <button type="button" @click="updateSearchTerm(neighborhood.neighborhoodPath ? neighborhood.neighborhoodPath : neighborhood.sitemapNeighborhoodPageUrl)">{{neighborhood.neighborhood ? neighborhood.neighborhood : neighborhood.displayName}}</button>
                    </li>
                </ul>
                <ul class="mvt-searchfilter-item hidden-default grid xs-grid-cols-1 gap-2" id="zipCodesList" v-if="getNearbyZipcodes && getNearbyZipcodes.length">
                    <li v-for="zipcode in getNearbyZipcodes" :key="zipcode.id">
                        <button type="button" @click="updateSearchTerm(zipcode.sitemapZipCodePageUrl)">{{zipcode.displayName}}</button>
                    </li>
                </ul>
                <ul class="mvt-searchfilter-item hidden-default grid xs-grid-cols-1 gap-2" id="countiesList" v-if="getNearbyCounties && getNearbyCounties.length">
                    <li v-for="county in getNearbyCounties" :key="county.id">
                        <button type="button" @click="updateSearchTerm(county.sitemapCountyPageUrl)">{{county.displayName}}</button>
                    </li>
                </ul>
            </mvtSearchFilter>
        </template>
        <searchListOnly v-else/>
    </div>
</template>

<script src="./page-search.js"></script>

<style lang="scss">
@use "./page-search.scss" as *;
</style>
